import React from 'react'

import { Grid, Input, SimpleCollapse } from 'components'
import { SPACING } from 'utils'
export interface ITipoEfetivoCollapse {
  control: any
  errors: any
}
const TipoEfetivoCollapse: React.FC<ITipoEfetivoCollapse> = ({
  control,
  errors
}) => {
  return (
    <SimpleCollapse title="TIPO DO EFETIVO">
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing5} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="CLT"
          placeholder="CLT"
          formValue="qtClt"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Sócio"
          placeholder="Sócio"
          formValue="qtSocio"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Cooperado"
          placeholder="Cooperado"
          formValue="qtCooperado"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Estrangeiro"
          placeholder="Estrangeiro"
          formValue="qtEstrangeiro"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="MEI"
          placeholder="MEI"
          formValue="qtMei"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Autônomo"
          placeholder="Autônomo"
          formValue="qtAutonomo"
          disabled
        />
      </Grid>
    </SimpleCollapse>
  )
}

export default TipoEfetivoCollapse
